<template>
    <el-row class="cabecera">
        <el-col :sm="8" align="left" class="hidden-xs-only">
            <img :src="Formar" style="width:60%; max-height:120px"/>
        </el-col>
        <el-col :xs="24" :sm="8" align="center">
            <img :src="Banner" style="width:75%"/>
        </el-col>
        <el-col :sm="8" align="right" class="hidden-xs-only">
            <img :src="Ministerio" style="width:80%; max-height:120px"/>
        </el-col>
    </el-row>
</template>



<script>
    export default
    {   name: 'Header',
        data()
        {   return {
                Banner:     'https://docentes.educaciondigitaltuc.gob.ar/assets/Banner.png',
                Formar:     'https://docentes.educaciondigitaltuc.gob.ar/assets/Formar.png',
                Ministerio: 'https://docentes.educaciondigitaltuc.gob.ar/assets/Ministerio.png',
            }
        }
    };
</script>



<style>
    .cabecera
    {   background: rgba(255,255,255,0.5);
    }
</style>
